import type { Compare } from '@festina-life/core'

import type { ComparableField } from '../../types/diffing'
import type { CompareFilter, CompareType } from './valueSetupCompareContext'
import { ValueSetupCompareProvider } from './ValueSetupCompareProvider'
import { ValueSetupComparisonDiff } from './ValueSetupComparisonDiff'

type Props = Compare<ComparableField> & {
  compareType: CompareType
  compareFilter?: CompareFilter
}

export const ValueSetupComparisonSelector = ({
  compareType,
  compareFilter,
  ...props
}: Props) => (
  <ValueSetupCompareProvider
    compareType={compareType}
    compareFilter={compareFilter}
  >
    <ValueSetupComparisonDiff {...props} />
  </ValueSetupCompareProvider>
)
